import React from 'react';
import styles from '../../../../styles/LeaderBoard.module.css';

interface TabOption {
  value: string;
  label: string;
}

interface LeaderboardTabsProps {
  tabs: TabOption[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const LeaderboardTabs: React.FC<LeaderboardTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className={styles.leaderboardTabs}>
      {tabs.map((tab) => (
        <div
          key={tab.value}
          className={`${styles.leaderboardTab} ${activeTab === tab.value ? styles.active : ''}`}
          onClick={() => onTabChange(tab.value)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default LeaderboardTabs;

